<script>
export let rink;
export let city;

</script>


<style>

.rink {
	display: block;
	margin-bottom: 1rem;
}

.rink:not(:last-child) {
	margin-bottom: 0.75rem;
	padding-bottom: 0.75rem;
	border-bottom: 1px solid #c7c7c7;
}

.rink * {
	/*text-align: center;*/
}

#rink-title {
	font-size: 1.05rem;
	font-weight: 500;
	color: var(--text-grey);
}

#rink-rules {
	margin-top: 0.5rem;
}

.rink-rule {
	font-size: 0.975rem;
	color: var(--text-light);
	margin-bottom: 0.25rem;
}

</style>


<div class="rink">

	<p id="rink-title">
		{rink.name} ({city.name})
	</p>

	<div id="rink-rules">

		{#each rink.rules as rule}

			<p class="rink-rule">
				{rule}
			</p>

		{/each}

	</div>

</div>


<!-- ... -->

